import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

const GetPenaltyData = () => {
    const [penaltyData, setPenaltyData] = useState([]);

    const [PageCount, setPageCount] = useState(1)
    const [editData, setEditData] = useState({
        penalty: '',
        message: '',
        id: ''
    });
    const [showModal, setShowModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewData, setViewData] = useState(null);

    const getPenaltyData = async (page) => {
        try {
            
            const requestOptions = {
                method: "GET",
                redirect: "follow"
              };
              
              fetch(`https://api.experts4u.in/api/v2/PenltySp/getAllPenltySp/${page}`, requestOptions)
                .then((response) => response.json())
                .then((result) => {console.log(result)
                    setPenaltyData(result.data);

                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error)
            
        }
    }

    const EditPenalty = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                penalty: editData.penalty,
                message: editData.message
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(`https://api.experts4u.in/api/v2/PenltySp/editPenlty/${editData.id}`, requestOptions);
            const result = await response.json();
            
            if (result.success) {
                Swal.fire("Updated!", "Penalty updated successfully.", "success");
                setShowModal(false);
                getPenaltyData(1);
            } else {
                Swal.fire("Error!", "Failed to update penalty.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error!", "Something went wrong.", "error");
        }
    }

    useEffect(() => {
        getPenaltyData(PageCount);
    }, [PageCount])

  return (
    <div className="container-fluid py-5 mt-4">
      <div className="row justify-content-center">
        <div className="col-md-11">

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">Penalty List</h4>
              

              <div className="d-flex justify-content-between align-items-center" style={{alignSelf: "center",alignContent: "center"}}>
                <div 
                style={{cursor: "pointer"}}
                onClick={() => PageCount > 1 && setPageCount(PageCount - 1)}
                >
                <FaAngleLeft />

                </div>
                <div className='mx-2 mt-3 ' style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <p>{PageCount}</p>
                </div>
                <div
                style={{cursor: "pointer"}}
                onClick={() => {penaltyData.length >= 10 && setPageCount(PageCount + 1)}}
                
                >
                    <FaAngleRight />
                </div>
              </div>
            </div>


            <table className="table table-striped table-hover">
              <thead>
                <tr>
                    <th>No .</th>
                  <th>Sp Name</th>
                  <th>Penalty Amount</th>
                  <th>Job Id</th>
                  <th>Message</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {penaltyData?.map((item,index) => (
                  <tr key={item?._id}>
                    <td>{index + 1}</td>
                    <td>{item?.SpId?.Name}</td>
                    <td>{item?.Penlty}</td>
                    <td>{item?.JobId}</td>
                    <td>{(item?.message).length > 20 ? (item?.message).substring(0, 20) + '...' : item?.message}</td>
                    <td>
                      <button className="btn btn-danger" onClick={() => {
                        const confirmBox = window.confirm(
                          "Do you really want to delete this?"
                        )
                        if (confirmBox === true) {
                          fetch(`https://api.experts4u.in/api/v2/PenltySp/deletePenlty/${item._id}`, {
                            method: "DELETE",
                          })
                            .then((response) => response.json())
                            .then((result) => {
                              console.log(result)
                              Swal.fire("Deleted!", "Penalty deleted successfully.", "success");
                              getPenaltyData(1);
                            })
                            .catch((error) => console.error(error));
                        }
                      }}>Delete</button>
                      <button className="btn btn-primary ml-2" onClick={() => {
                        setEditData({
                            penalty: item.Penlty,
                            message: item.message,
                            id: item._id
                        });
                        setShowModal(true);
                      }}>Edit</button>
                      <button className="btn btn-primary ml-2" onClick={() => {
                        setViewData(item);
                        setShowViewModal(true);
                      }}>View</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Edit Modal */}
            {showModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Penalty</h5>
                                <button type="button" className="close" onClick={() => setShowModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Penalty Amount</label>
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        value={editData.penalty}
                                        onChange={(e) => setEditData({...editData, penalty: e.target.value})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Message</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={editData.message}
                                        onChange={(e) => setEditData({...editData, message: e.target.value})}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={EditPenalty}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* View Modal */}
            {showViewModal && viewData && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">View Penalty Details</h5>
                                <button type="button" className="close" onClick={() => setShowViewModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col-4 font-weight-bold">SP Name:</div>
                                    <div className="col-8">{viewData?.SpId?.Name}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4 font-weight-bold">Penalty Amount:</div>
                                    <div className="col-8">{viewData?.Penlty}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4 font-weight-bold">Job ID:</div>
                                    <div className="col-8">{viewData?.JobId}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4 font-weight-bold">Message:</div>
                                    <div className="col-8" style={{ whiteSpace: 'pre-wrap' }}>{viewData?.message}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4 font-weight-bold">Created At:</div>
                                    <div className="col-8">{new Date(viewData?.createdAt).toLocaleString()}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4 font-weight-bold">Updated At:</div>
                                    <div className="col-8">{new Date(viewData?.updatedAt).toLocaleString()}</div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowViewModal(false)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
      </div>
    </div>
  )
}

export default GetPenaltyData